module.exports = __webpack_public_path__ + "img/Betalingsoverzicht.995dba23.png";